// ==============================|| OVERRIDES - CARD ACTIONS ||============================== //

export default function CardActions() {
  return {
    MuiCardActions: {
      variants: [
        {
          props: { variant: 'landing-card-actions' },
          style: {
            padding: '16px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          }
        }
      ],
      styleOverrides: {
        root: {
          padding: '24px'
        }
      }
    }
  };
}
